import { Controller } from "@hotwired/stimulus"

// «Agregar persona nueva» (ADR 0090): adds a ticked row for a person who isn't on the Farm, cloned from the row the
// server rendered in the template. __NEW__ in its field names and values becomes a numeric key unique to the row (Rails
// permits only numeric keys in a hash of rows); the name
// fills [data-new-person-name] inputs and texts. The Contractor is created only when the form saves.
export default class extends Controller {
  static targets = ["input", "template", "list"]

  add() {
    const name = this.inputTarget.value.trim()
    if (!name) return

    const key = `${Date.now()}${this.element.querySelectorAll("[data-new-person-row]").length}`
    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    row.querySelectorAll("input").forEach((input) => {
      input.name = input.name.replace("__NEW__", key)
      input.value = input.value.replace("__NEW__", key)
    })
    row.querySelectorAll("[data-new-person-name]").forEach((element) => {
      if (element.tagName === "INPUT") element.value = name
      else element.textContent = name
    })

    this.listTarget.append(row)
    this.inputTarget.value = ""
    this.dispatch("added", { detail: { row } })
  }
}
